import axios from "axios"
import { Community } from "../types"

export const updateCommunity = async (communityId: string, community: Partial<Community>) => {
  try {
    const formData = new FormData()
    Object.entries(community).forEach(([k, v]) => v && formData.append(k, v))

    const res = await axios.post(`/communities/${communityId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return res.data
  } catch (err) {
    console.log("updateCommunity err", err)
  }

  return null
}
